<template>
  <v-dialog v-model="visible" max-width="900px" :fullscreen="isMobile">
    <v-card class="cps-card">

      <!-- Header (styled like EditPermisosUserModal) -->
      <div class="cps-header">
        <div class="d-flex align-center" style="gap: 12px;">
          <div class="cps-avatar">
            <v-icon color="white" size="20">mdi-cash-check</v-icon>
          </div>
          <div>
            <p class="cps-title mb-0">Crear Nuevo Estado de Pago</p>
            <p class="cps-subtitle mb-0">Ingresa el porcentaje de avance por adicional</p>
          </div>
        </div>
        <v-btn icon small @click="onCancel" class="cps-close-btn">
          <v-icon size="18" color="white">mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="pa-0 cps-scrollable-content">
        <div class="cps-body">
					<div v-if="hiddenCount > 0" class="cps-warning">
						<v-icon size="15" color="#b45309" class="mr-1">mdi-eye-off-outline</v-icon>
						<span>
							{{ hiddenCount }} adicional{{ hiddenCount > 1 ? 'es' : '' }} 
							{{ hiddenCount > 1 ? 'no se muestran' : 'no se muestra' }} 
							porque {{ hiddenCount > 1 ? 'ya alcanzaron' : 'ya alcanzó' }} el 100% de avance financiero.
						</span>
					</div>
          <div v-if="!eligibleRows || eligibleRows.length === 0">
            <p class="cps-hint">No hay adicionales disponibles para agregar estados de pago.</p>
          </div>

          <div v-else>
            <!-- Column headers -->
            <div class="cps-col-headers d-none d-sm-flex">
              <div class="cps-col-header-left">Adicional</div>
              <div class="cps-col-header-right">Avance a ingresar</div>
            </div>

            <v-row
              v-for="(row) in eligibleRows"
              :key="row.additional.id"
              align="center"
              dense
              class="cps-row mx-0"
            >
              <!-- LEFT: read-only info (unchanged from original) -->
              <v-col :cols="isMobile ? 12 : 7" class="cps-col-info">
								<div class="d-flex align-center mb-1" style="gap:5px;">
									<div class="cps-badge-additional-number">
										<p class="mb-0">Adicional</p>
										<p class="mb-0 font-weight-bold caption">Nº{{ row.additional.number }}</p>
									</div>
									<div>
										<div class="font-weight-bold additional-list-title caption mb-0" v-html="row.additional.title"></div>
										<div class="d-flex align-center" style="gap: 5px;">
											<p class="caption font-weight-bold mb-0 text--disabled">Tipo:</p>
											<p class="mb-0 caption font-weight-bold">{{ getAdditionalType(row.additional.type) }} - {{ getAdditionalCostType(row.additional.cost_type) }}</p>
										</div>
									</div>
								</div>
                <v-divider class="my-1"></v-divider>
                <div class="d-flex" style="gap:5px;">
                  <div class="flex-1" style="flex-basis:50%; overflow:hidden; min-width:0;">
                    <p class="mb-0 body-2 text--secondary caption">
                      <v-icon color="#2D4B95" class="mr-1" small>mdi-clipboard-edit-outline</v-icon>
                      <span class="normal font-weight-bold">{{ row.additional.statustext }}</span>
                    </p>
                    <div>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div class="d-flex flex-row justify-start align-center" v-bind="attrs" v-on="on">
                            <div class="d-flex flex-row align-center mr-1">
                              <v-icon color="#2D4B95" class="mr-1" small>mdi-currency-usd</v-icon>
                              <p class="mb-0 normal caption font-weight-bold">{{ prependToValueAdditional(row.additional) }}{{ row.additional.last_revision?.total_requested | toThousandFilter(informativeTableCurrencyInfo?.code === 'UF' ? 2 : 0) }}</p>
                            </div>
                          </div>
                        </template>
                        <span>{{ row.additional.approved_status ? 'Monto Aprobado en última revisión.' : 'Monto Actual.' }}</span>
                      </v-tooltip>
                    </div>
                    <div v-if="informativeTableCurrencyInfo.id != row.additional.last_revision?.currency_info?.id">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div class="d-flex flex-row justify-start align-center" style="opacity:0.8;" v-bind="attrs" v-on="on">
                            <div class="d-flex flex-row align-center mr-1">
                              <v-icon color="grey" class="mr-1" small>mdi-currency-usd</v-icon>
                              <p class="mb-0 caption font-weight-bold grey--text">{{ prependToValue }}{{ row.additional.last_revision?.total_requested_converted | toThousandFilter(informativeTableCurrencyInfo?.code === 'UF' ? 2 : 0) }}</p>
                              <v-icon color="grey" class="ml-1" small>mdi-information-outline</v-icon>
                            </div>
                          </div>
                        </template>
                        <span>{{ row.additional.approved_status ? 'Monto Aprobado. Valor referencial.' : 'Monto Actual. Valor referencial.' }}</span>
                      </v-tooltip>
                    </div>
                    <div>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div class="d-flex flex-row justify-start align-center" v-bind="attrs" v-on="on">
                            <div class="d-flex flex-row align-center mr-1">
                              <v-icon color="#2D4B95" class="mr-1" small>mdi-calendar</v-icon>
                              <p class="mb-0 normal caption font-weight-bold">{{ row.additional.last_revision.created_at | toDate }}</p>
                            </div>
                          </div>
                        </template>
                        <span>Fecha Última Revisión</span>
                      </v-tooltip>
                    </div>
                    <div>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div class="d-flex flex-row justify-start align-center" v-if="row.additional.approved_status_change" v-bind="attrs" v-on="on">
                            <div class="d-flex flex-row align-center mr-1">
                              <v-icon color="#2D4B95" class="mr-1" small>mdi-calendar-check</v-icon>
                              <p class="mb-0 normal caption font-weight-bold">{{ row.additional.approved_status_change.created_at | toDate }}</p>
                            </div>
                          </div>
                        </template>
                        <span>Fecha Acuerdo</span>
                      </v-tooltip>
                    </div>
                  </div>
                  <v-divider vertical></v-divider>
                  <div class="flex-1" style="flex-basis:50%; overflow:hidden; min-width:0;">
                    <div class="caption" style="margin-right:1px;">
                      <div class="d-flex flex-row align-center my-0 mr-1">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <div class="d-flex flex-row align-center mr-1" v-bind="attrs" v-on="on">
                              <v-icon color="normal" class="mr-1" small>mdi-currency-usd</v-icon>
                              <p class="mb-0 mr-2 normal font-weight-bold">{{ prependToValue }}{{ row.additional.total_amount_converted | toThousandFilter(informativeTableCurrencyInfo?.code === 'UF' ? 2 : 0) }}</p>
                            </div>
                          </template>
                          <span>Monto total acumulado (aprobado)</span>
                        </v-tooltip>
                      </div>
                      <div class="d-flex flex-row align-center my-0 mr-1">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <div class="d-flex flex-row align-center mr-1" v-bind="attrs" v-on="on">
                              <v-icon color="medium" class="mr-1" small>mdi-currency-usd</v-icon>
                              <p class="mb-0 mr-2 medium font-weight-bold">{{ prependToValue }}{{ (row.additional.last_revision?.total_requested_converted - row.additional.total_amount_converted) | toThousandFilter(informativeTableCurrencyInfo?.code === 'UF' ? 2 : 0) }}</p>
                            </div>
                          </template>
                          <span>Saldo por pagar / aprobar</span>
                        </v-tooltip>
                      </div>
                      <v-divider class="mt-1"></v-divider>
                      <div>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <p class="mb-0 font-weight-bold" style="font-size: 10px;" v-bind="attrs" v-on="on">Avance Financiero</p>
                          </template>
                          <span>Porcentaje de avance de acuerdo a los adicionales aprobados</span>
                        </v-tooltip>
                        <v-progress-linear :value="row.additional.total_progress*100" color="primary" height="10" rounded>
                          <p class="mb-0" style="font-size:9px;" :class="row.additional.total_progress < 0.43 ? '' : 'white--text'">{{ Math.round(row.additional.total_progress*100) }}%</p>
                        </v-progress-linear>
                      </div>
                      <div>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <p class="mb-0 font-weight-bold" style="font-size:10px;" v-bind="attrs" v-on="on">
                              Avance Físico (<span v-if="row.additional.last_progress">{{ row.additional.last_progress.updated_at | toDate }}</span><span v-else>--</span>)
                            </p>
                          </template>
                          <span>Último porcentaje de avance físico informado</span>
                        </v-tooltip>
                        <div class="d-flex align-center">
                          <v-progress-linear v-if="row.additional.last_progress" :value="row.additional.last_progress.physical_progress*100" color="primary" height="10" rounded>
                            <p class="mb-0" style="font-size:9px;" :class="row.additional.last_progress.physical_progress < 0.43 ? '' : 'white--text'">{{ Math.round(row.additional.last_progress.physical_progress*100) }}%</p>
                          </v-progress-linear>
                          <div class="flex-grow-1" v-else>
                            <p class="mb-0 caption">No informado</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-col>

              <!-- RIGHT: compact input (based on NewPaymentStatusAdditionalForm) -->
              <v-col :cols="isMobile ? 12 : 5" class="cps-col-input">
                <div class="cps-input-wrapper">
                  <p class="mb-1 font-weight-bold caption">Porcentaje de avance</p>
                  <v-text-field
                    v-model.number="row.percentage"
                    placeholder="% Avance"
                    type="number"
                    min="0"
                    :max="row.additional.cost_type === 1 ? maxAllowed(row.additional) : undefined"
                    outlined
                    dense
                    hide-details
                    class="cps-percent-input"
                    @input="val => onPercentageInput(row, val)"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div class="d-flex flex-row justify-end align-center mt-1" v-bind="attrs" v-on="on">
                        <v-icon color="#2D4B95" class="mr-1" small>mdi-currency-usd</v-icon>
                        <p class="mb-0 normal caption font-weight-bold">
                          {{ prependToValue }}{{ computeAmount(row.additional, row.percentage) | toThousandFilter(informativeTableCurrencyInfo?.code === 'UF' ? 2 : 0) }}
                        </p>
                      </div>
                    </template>
                    <span>Monto correspondiente</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </div>

        </div>
      </v-card-text>

      <!-- Footer (styled like EditPermisosUserModal) -->
      <div class="cps-footer">
        <v-btn rounded outlined depressed class="cps-btn-cancel" @click="onCancel">
          Cancelar
        </v-btn>
				<v-btn
					rounded depressed color="#2D4B95" dark
					class="cps-btn-confirm"
					:loading="loading"
					:disabled="preparePayload().length === 0"
					@click="createPaymentStatus"
				>
					<v-icon left small>mdi-check</v-icon>
					Confirmar
				</v-btn>
      </div>

    </v-card>
  </v-dialog>
</template>

<script>
import { newPaymentStatus } from '@/helpers/api/additionals'

export default {
  name: 'CreatePaymentStatusModal',
  props: {
    value: { type: Boolean, default: false },
    additionals: { type: Array, default: () => [] },
    selectedCurrency: { type: Number, default: 2 }
  },
  data() {
    return {
      visible: this.value,
      rows: [],
      loading: false
    }
  },
  watch: {
    value(val) { this.visible = val },
    visible(val) { 
      if (!val) this.resetRows();
      // Emit both events to support v-model (`input`) and .sync (`update:value`)
      this.$emit('input', val)
      this.$emit('update:value', val)
    },
    additionals: {
      handler() { this.buildRows() },
      deep: true
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
		hiddenCount() {
			return this.rows.length - this.eligibleRows.length
		},
    informativeTableCurrencyInfo() {
      return this.$store.adicionalesStore.state.listadoInformativeTable.currency_info || {}
    },
    prependToValue() {
      const code = this.informativeTableCurrencyInfo?.code || 'CLP'
      const symbol = this.informativeTableCurrencyInfo?.symbol || '$'
      if (code != 'UF') { return `${code} ${symbol}` }
      return `${code} `
    },
    // Only show additionals where more payment can be added (mirrors isAbleToAdd)
    eligibleRows() {
      return this.rows.filter(row => {
        const total_progress = row.additional.total_progress * 100
        return total_progress < 100 || row.additional.cost_type !== 1
      })
    }
  },
  methods: {
    buildRows() {
      this.rows = (this.additionals || []).map(a => ({ additional: a, percentage: null }))
    },
    resetRows() {
      this.rows = (this.additionals || []).map(a => ({ additional: a, percentage: null }))
    },
    maxAllowed(additional) {
      return Math.round(100 - additional.total_progress * 100)
    },
    onPercentageInput(row, val) {
      if (row.additional.cost_type === 1) {
        const max = this.maxAllowed(row.additional)
        if (val > max) {
          row.percentage = max
          const datas = {
            message: `El porcentaje de avance no puede ser mayor a ${max}. Se ha ajustado automáticamente.`,
            title: 'Aviso',
            created: new Date(),
            type: 'warning',
            icon: 'mdi-alert-circle',
            color: '#fb8c00'
          }
          this.$store.globalStore.dispatch('addMessage', datas)
        }
      }
    },
    getAdditionalType(additionalType) {
      const found = this.$store.adicionalesStore.state.additionalTypes.find(type => type.id === additionalType)
      return found ? found.name : '--'
    },
    getAdditionalCostType(additionalCostType) {
      const found = this.$store.adicionalesStore.state.additionalCostTypes.find(type => type.id === additionalCostType)
      return found ? found.name : '--'
    },
    prependToValueAdditional(additional) {
      const code = additional?.last_revision?.currency_info?.code || 'CLP'
      const symbol = additional?.last_revision?.currency_info?.symbol || '$'
      if (code != 'UF') { return `${code} ${symbol}` }
      return `${code} `
    },
    computeAmount(additional, percentage) {
      if (!percentage || percentage === 0) return 0
      return +parseFloat((additional.last_revision?.total_requested || 0) * percentage / 100).toFixed(2)
    },
    preparePayload() {
      return this.eligibleRows
        .filter(r => r.percentage && r.percentage > 0)
        .map(r => ({
          additional_id: r.additional.id,
          progress: r.percentage / 100,
          amount: this.computeAmount(r.additional, r.percentage)
        }))
    },
    async createPaymentStatus() {
      const additionals_included = this.preparePayload()
      if (additionals_included.length === 0) return
      const data = {
        project_id: this.$store.projectsStore.state.selectedProject.id,
        additionals_included
      }
      this.loading = true
      try {
        await newPaymentStatus(data)
        this.$emit('created')
        this.visible = false
      } catch (error) {
        this.$store.globalStore.dispatch('addMessage', {
          message: 'Hubo un error al crear el estado de pago. Por favor intenta nuevamente.',
          title: 'Error',
          created: new Date(),
          type: 'warning',
          icon: 'mdi-alert-circle',
          color: '#fb8c00'
        })
      } finally {
        this.loading = false
      }
    },
    onCancel() {
      this.visible = false
    }
  },
  mounted() {
    this.buildRows()
  }
}
</script>

<style scoped>
/* Header */
.cps-header {
  background-color: #1C3A7A;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.cps-avatar {
  width: 38px; height: 38px; border-radius: 50%;
  background: rgba(255,255,255,0.15);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.cps-title   { font-size: 14px; font-weight: 400; color: #ffffff; }
.cps-subtitle{ font-size: 11px; color: rgba(255,255,255,0.6); }
.cps-close-btn { background: rgba(255,255,255,0.1) !important; }
.cps-close-btn:hover { background: rgba(220,60,60,0.45) !important; }

/* Body */
.cps-body { padding: 16px 20px 8px; }
.cps-hint  { font-size: 12px; color: #707070; line-height: 1.6; margin-bottom: 16px; }

/* Column headers */
.cps-col-headers {
  display: flex;
  padding: 0 12px 6px;
  gap: 0;
}
.cps-col-header-left  { flex: 7; font-size: 11px; font-weight: 500; color: #888; text-transform: uppercase; letter-spacing: 0.06em; }
.cps-col-header-right { flex: 5; font-size: 11px; font-weight: 500; color: #888; text-transform: uppercase; letter-spacing: 0.06em; }

/* Row */
.cps-row {
  border: 1px solid #E0E6F5;
  border-radius: 10px;
  margin-bottom: 8px !important;
  padding: 10px 4px;
}
.cps-col-info  { padding: 6px 10px; }
.cps-col-input {
  padding: 6px 12px;
  border-left: 1px solid #E0E6F5;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Compact input (matches NewPaymentStatusAdditionalForm style) */
.cps-input-wrapper { width: 100%; max-width: 180px; }

/deep/ .cps-percent-input .v-input__slot {
  padding: 0 8px !important;
  min-height: 30px !important;
}
/deep/ .cps-percent-input input {
  text-align: center;
  font-size: 12px;
  padding: 0;
}
/deep/ .cps-percent-input .v-input__prepend-inner,
/deep/ .cps-percent-input .v-input__append-inner {
  margin-top: 0 !important;
}

/* Footer */
.cps-footer {
  display: flex; justify-content: flex-end; align-items: center;
  gap: 8px; padding: 14px 20px; border-top: 1px solid #F0F0F0;
}
.cps-btn-cancel { color: #2D4B95 !important; border-color: #C5D0EA !important; }

/* Color tokens from existing code */
.normal { color: #3EBFA3; }
.medium { color: #fb8c00; }

/* Card con layout flex para footer fijo */
.cps-card {
  display: flex !important;
  flex-direction: column !important;
  max-height: 90vh;
}

/* Área scrolleable */
.cps-scrollable-content {
  overflow-y: auto;
  flex: 1 1 auto;
}

/* Warning de adicionales ocultos */
.cps-warning {
  display: flex;
  align-items: center;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-radius: 8px;
  padding: 8px 12px;
  margin-bottom: 14px;
  font-size: 12px;
  color: #92400e;
  line-height: 1.4;
}

.cps-badge-additional-number {
	background-color: #5E85EF;
	color: white;
	text-align: center;
	font-size: 10px;
	line-height: 1;
	font-weight: 500;
	padding: 4px 8px;
	border-radius: 4px;
}

/* Footer fijo */
.cps-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 14px 20px;
  border-top: 1px solid #F0F0F0;
  background: white;
  flex-shrink: 0;       /* no se comprime con el scroll */
  position: sticky;
  bottom: 0;
  z-index: 1;
}

/* Botón confirmar: visible también en disabled */
/deep/ .cps-btn-confirm.v-btn.v-btn--disabled:not(.v-btn--loading) {
  background-color: #8fa8d6 !important;
  color: white !important;
  opacity: 1 !important;
}

/deep/ .cps-btn-confirm.v-btn.v-btn--disabled:not(.v-btn--loading) .v-btn__content {
  color: white !important;
  opacity: 1 !important;
}
</style>